var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaikin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 538,
    viewBox: "1 1 298 62.617",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m68.872 1h-67.87v62.617z",
    fill: "#44c8f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34.93 1h-33.93v31.323z",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m163.645 14.591-8.86 35.422h15.654l8.853-35.422zm-35.75 20.529h-3.59l5.789-10.218 1.877 10.219zm-2.227-20.533-20.13 35.42h10.352l3.342-5.903h14.372l1.07 5.904h15.28l-6.494-35.42zm109.463.004-8.836 35.422h15.65l8.837-35.422zm-6.995 0h-16.04l-13.425 11.587 2.93-11.587h-15.003l-8.836 35.422h14.956l3.055-12.228 7.997 12.228h18.103l-13.408-18.55zm-134.882 16.097s-1.016 11.506-10.82 11.506h-5.547l4.886-19.106h5.034c1.801.011 7.015.479 6.447 7.6zm-.793-16.08-4.049-.013h-19.585l-8.837 35.407h19.448l7.694.011c10.833 0 21.494-8.064 21.494-20.416 0-14.533-16.166-14.99-16.166-14.99m195.705-.021-5.22 20.857-6.956-20.857h-17.407l-8.843 35.427h10.824l5.271-21.04 6.977 21.04h17.333l8.856-35.427z",
    fill: "#00a0e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaikin);
export default __webpack_public_path__ + "static/media/daikin.f50996431309425c6686035a02375a6b.svg";
export { ForwardRef as ReactComponent };